import React from 'react'
import { type LucideProps } from 'lucide-react'

const Templates: React.FC<LucideProps> = (props: LucideProps) => (
  <svg
  width={26}
  height={17}
  viewBox="0 0 26 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M14.9343 2.17772V5.64387H11.7463V0.0864258H0.840332V11.1956H6.56304V16.7531H17.469L17.4679 13.2858H25.8403V2.17772H14.9343ZM6.56304 10.3943H1.62616V0.886612H10.9599V5.64274L6.56332 5.64384L6.56304 10.3943ZM16.6824 15.9518H7.34859V6.44405H16.6824V15.9518ZM25.0548 12.4856H17.4682V5.64387H15.7212V2.97793H25.055L25.0548 12.4856Z"
    fill="#949494"
  />
</svg>

)

export default Templates
